var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.paymentMethods)?_c('div',[_c('div',{staticClass:"fluid-xs leading-snug uppercase font-medium mb-4"},[_vm._v(_vm._s(_vm.$t('navigation.paymentMethods')))]),_vm._v(" "),_c('PaymentMethodsIcons',{attrs:{"methods":_vm.paymentMethods}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }